import React from 'react';

import { Attachment } from '../Attachment';
import { GateOverlay } from './GateOverlay';
import { RelatedPapers } from '../interstitials/RelatedPapers';
import { RelatedPaper } from '../interstitials/types';

type GatedAttachmentVariant = 'blur_page_2';

export type GatedAttachmentProps = {
  attachmentId: string;
  firstPageUrl?: string;
  totalPages: number;
  universityCount: number;
  variant: GatedAttachmentVariant;
  className?: string;
  relatedPapers?: RelatedPaper[];
  userInChina: boolean;
};

export const GatedAttachment: React.FC<GatedAttachmentProps> = ({
  attachmentId,
  firstPageUrl,
  universityCount,
  className,
  relatedPapers = [],
  userInChina,
}) => {
  const visiblePages = 1; // blur_page_2: show only page 1

  return (
    <div className={className}>
      <div className="gated-attachment__pdf-area">
        <Attachment
          attachmentId={attachmentId}
          firstPageUrl={firstPageUrl}
          pages={visiblePages}
          shown={true}
          className="ungated-pdf-viewer-panel__attachment"
          trailingPageClassName="gated-attachment__blurred-page"
        />
        {firstPageUrl && (
          <div className="gated-attachment__overlay-positioner">
            <GateOverlay
              universityCount={universityCount}
              userInChina={userInChina}
            />
          </div>
        )}
      </div>
      <RelatedPapers papers={relatedPapers} marginBottom={false} />
    </div>
  );
};
